import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../core/services/contact-us.service';
import { LanguageService } from '../core/services/language.service';

@Component({
  selector: 'app-get-help-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './get-help-login.component.html',
  styleUrl: './get-help-login.component.css'
})
export class GetHelpLoginComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  form: FormGroup;

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService, private languageService: LanguageService) {}

  get labels() { return this.contactUsService.commonLabels; }
  get placeholders() { return this.contactUsService.placeholderTextLabels; }
  get messages() { return this.contactUsService.messageLabels; }

  get listLabels() { return this.contactUsService.listLabels; }

  portals: { key: string; label: string }[] = [];

  ngOnInit() {
    const lang = this.languageService.getLanguageFromUrl();

    this.form = this.fb.group({
      portalName: ['', [Validators.required]],
      otherPortal: [''],
      portalURL: [''],
      region: [lang === 'fr-fr' ? 'FR' : lang === 'en-us' ? 'US' : 'INT'],
      description: ['', [Validators.required, Validators.minLength(20)]]
    });

    this.form.get('portalName')?.valueChanges.subscribe(value => {
      const otherPortal = this.form.get('otherPortal');
      if (value === 'other') {
        otherPortal?.setValidators([Validators.required]);
      } else {
        otherPortal?.clearValidators();
        otherPortal?.setValue('');
      }
      otherPortal?.updateValueAndValidity();
    });

    this.formReady.emit(this.form);

    this.contactUsService.getDictionary(lang).subscribe(() => {
      const portals = this.listLabels.portals;
      if (portals) {
        const mapped = Object.keys(portals).map(key => ({ key, label: (portals as any)[key] }));
        const other = mapped.filter(p => p.key === 'other');
        const rest = mapped.filter(p => p.key !== 'other').sort((a, b) => a.label.localeCompare(b.label));
        this.portals = [...rest, ...other];
      } else {
        this.portals = [];
      }
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }
}
